import React, { useState, useEffect } from 'react';
import cn from 'classnames';

import styles from './SelectYesNo.module.css';

const SelectYesNo = (props) => {
  const {
    onChange,
    defaultValue,
  } = props;

  const [yes, setYes] = useState(defaultValue);

  useEffect(() => {
    setYes(defaultValue);
  }, [defaultValue]);

  const onChangeHandler = (value) => {
    onChange(value);
    setYes(value);
  };

  return (
    <div className={styles.wrapper}>
      <div
        className={cn(styles.button, 'select-button', { [styles.active]: yes === false })}
        onClick={() => onChangeHandler(false)}
      >
        No
      </div>
      <div
        className={cn(styles.button, 'select-button', { [styles.active]: yes === true })}
        onClick={() => onChangeHandler(true)}
      >
        Yes
      </div>
    </div>
  );
};

export default SelectYesNo;
